import React, { useState, useEffect } from "react";
import "./ImageCellFullModal.css";
import { useEscapeKey } from "../../hooks/useEscapeKey";
import ImageCellFullInfo from "./ImageCellFullModalInfo";
//import { X } from "lucide-react";
import LoadingSquare from "../Common/LoadingSquare";

const ImageCellFullModal = ({ img, onClose, onOpenStreetView }) => {
  const [imageSrc, setImageSrc] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // URL de l'image
  const fullSrc = `${process.env.PUBLIC_URL}/images_compress/full/${img.id}`;

  useEffect(() => {
    let isMounted = true;

    const loadImage = async () => {
      try {
        setIsLoading(true);

        // Charger directement l'image complète
        const fullImage = new Image();
        fullImage.src = fullSrc;

        await new Promise((resolve) => {
          fullImage.onload = resolve;
          fullImage.onerror = resolve;
        });

        if (isMounted && fullImage.complete) {
          setImageSrc(fullSrc);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Erreur lors du chargement de l'image:", error);
        if (isMounted) {
          setImageSrc(fullSrc);
          setIsLoading(false);
        }
      }
    };

    loadImage();

    return () => {
      isMounted = false;
    };
  }, [fullSrc]);

  const handleClick = (evt) => {
    /*if (evt.target.classList.contains("image-full-modal")) {
      onClose();
    }*/ onClose();
  };

  useEscapeKey(onClose);

  return (
    <div
      className="image-full-modal"
      style={{ backgroundColor: isLoading ? img.bgColor : img.bgColor }}
      onClick={handleClick}
    >
      {/* Icône X positionnée en haut à droite 
      <div className="image-full-close" onClick={onClose}>
        <X size={24} strokeWidth={2} />
      </div>*/}

      {/* Conteneur des infos */}
      <ImageCellFullInfo img={img} onOpenStreetView={onOpenStreetView} />

      {/* Image */}
      {imageSrc && (
        <img
          src={imageSrc}
          alt={img.nyme}
          className={`image-full-img ${
            isLoading ? "image-loading" : "image-loaded"
          }`}
          style={{
            opacity: isLoading ? 0 : 1,
            filter: isLoading ? "blur(5px)" : "blur(0px)",
            transition: "opacity 0.3s ease, filter 0.3s ease",
          }}
          onLoad={() => {
            if (imageSrc === fullSrc) {
              setIsLoading(false);
            }
          }}
        />
      )}

      {/* Indicateur de chargement optionnel */}
      {/*isLoading && (
        <div className="image-loading-indicator" style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'var(--colorFront)',
          fontSize: '14px',
          zIndex: 1
        }}>
          Chargement...
        </div>
      )*/}

      {/*isLoading && <LoadingSquare color={img.typoloColor} />*/}
      <LoadingSquare color={img.typoloColor} isLoaded={!isLoading} />
    </div>
  );
};

export default ImageCellFullModal;
